module.exports = __webpack_public_path__ + "img/bg-m-dark.7f4d9276.png";